import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { sendLogout } from '@/api/auth/auth.actions';

const SignOut: FC = () => {
  const router = useNavigate();

  useEffect(() => {
    const signOut = async (): Promise<void> => {
      const response = await sendLogout();

      if (!response.success && response.error.code === 401) {
        toast.error('You are not signed in');
      } else {
        toast.success(response.message);
      }

      router('/sign-in');
    };

    signOut();
  }, [router]);
  return <div />;
};

export default SignOut;
